import { IPatient, v2, constants } from '../../..';
import { getHcpAttributeNames } from './helpers/getHcpAttributeNames';

type NoteParts = Pick<IPatient, 'notes' | 'postVisitNotes' | 'postVisitNotesBuddy'>;

const getNoteAttributeName = (note: v2.Note) => {
    const isBuddy = note.createdById === constants.HCP2;
    const { postVisitNotes } = getHcpAttributeNames(isBuddy);
    return postVisitNotes;
};

export const noteAdapter = (notes: v2.Note[]): NoteParts => {
    const result: NoteParts = {};

    notes.forEach((note) => {
        const { noteType, text } = note;

        if (noteType === 'PRE_VISIT') {
            result.notes = text;
        } else if (noteType === 'POST_VISIT') {
            const attributeName = getNoteAttributeName(note);
            result[attributeName] = text;
        }
    });

    return result;
};
